module.exports = __webpack_public_path__ + "static/img/Slice 2@2x.cf812aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/pc/Slice 2@2x.png
// module id = ciVx
// module chunks = 1